module.exports = __webpack_public_path__ + "static/4-9d91ecab5f487f94a692e26dda1b3ce8.jpg";